// Decode: overlines resolve from random characters into their text when they scroll into view, left to right, like
// text being generated. Screen readers get the final text at once (a visually hidden copy); the animated letters
// are hidden from them, and the plain text is put back when it is done. Skipped with reduced motion.
import { onceVisible, reducedMotion } from './motion.js'

const GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/<>#*+'
const STEP = 26 // ms per frame of the animation
const DELAY = 1.4 // frames between two letters resolving
const SCRAMBLE = 7 // frames a letter scrambles before it resolves

export function initDecode() {
	if (reducedMotion.matches) return
	const overlines = [...document.querySelectorAll('.overline')].filter((line) => !line.children.length && line.textContent.trim())
	onceVisible(overlines, decode, '0px 0px -8% 0px')
}

function decode(line) {
	const text = line.textContent
	const letters = [...text]
	const hidden = document.createElement('span')
	hidden.className = 'visually-hidden'
	hidden.textContent = text
	const shown = document.createElement('span')
	shown.setAttribute('aria-hidden', 'true')
	line.replaceChildren(hidden, shown)

	let frame = 0
	const last = letters.length * DELAY + SCRAMBLE
	const timer = setInterval(() => {
		frame++
		if (frame >= last) {
			clearInterval(timer)
			line.textContent = text
			return
		}
		shown.textContent = letters
			.map((letter, index) => {
				const start = index * DELAY
				if (/\s/.test(letter) || frame >= start + SCRAMBLE) return letter
				return frame < start ? '' : GLYPHS[Math.floor(Math.random() * GLYPHS.length)]
			})
			.join('')
	}, STEP)
}
